import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable()
export class TitleService {

    private titleObs$: BehaviorSubject<String> = new BehaviorSubject("");

    getTitleObs(): Observable<String> {
        return this.titleObs$.asObservable();
    }

    setTitleObs(title: String) {
        this.titleObs$.next(title);
    }


}